import request from '../utils/request'


export function index(params) {
    return request({
        url: '/formLogo',
        method: 'get',
        params
    })
}

export function show(id) {
    return request({
        url: `/formLogo/${id}`,
        method: 'get'
    })
}

export function store(data) {
    return request({
        url: '/formLogo',
        method: 'post',
        data
    })
}

export function update(data) {
    return request({
        url: `/formLogo/${data.id}`,
        method: 'put',
        data
    })
}

export function destroy(id) {
    return request({
        url: `/formLogo/${id}`,
        method: 'delete',
    })
}